// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"index-module--mainContainer--3tHif","center":"index-module--center--ydUMp","left":"index-module--left--1HKIi","coursework":"index-module--coursework--2kh0o"};